<template>
  <div>
		<div class="footer">
  		<p>山东客汇软件有限公司    &nbsp;&nbsp; 联系我们: 400-0127567</p>
      <p>信息安全举报电话：05368806666 &nbsp;&nbsp;举报邮箱：sdkhrj@126.com</p>
  		<p>电信业务经营许可证：B2-20192181     公安备案号：37070502000375</p>
  		<p><a href="http://www.miit.gov.cn">鲁ICP备18049793号-4</a></p>
  	</div> 		
  </div>
</template>

<script>
import qs from "qs"			
import myheader from "@/components/header"
export default {
	components:{
		myheader
	},
  data () {
    return {}

  },
  methods:{

  },
  created:function(){

  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myfooter.vue